module.exports = __webpack_public_path__ + "img/mine30Deposit.13d7518a.webp";